module.exports = __webpack_public_path__ + "static/img/channel-wchat.19a631e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/channel-wchat.jpg
// module id = +isD
// module chunks = 0